import axios, { AxiosInstance } from 'axios';
import {
  IManager,
  IResetPasswordRequest,
  ISigninRequest,
  ITokens
} from '../commons/interfaces/auth.interface';
import { IChatbotAPIResponse } from '../commons/interfaces/chatbotAPI.interface';
import TokenService from './token.service';

export default class AuthAPI {
  private request: AxiosInstance;

  constructor() {
    this.request = axios.create({
      baseURL: process.env.REACT_APP_SERVER_HOST,
      headers: { 'Content-Type': 'application/json' }
    });
  }

  signin = async (requestData: ISigninRequest) => {
    const response = await this.request.post<IChatbotAPIResponse<ITokens>>(
      '/auth/managers/signin',
      requestData
    );

    const tokens = response.data.data;

    TokenService.setTokens(tokens);
    return TokenService.getDataFromToken() as IManager;
  };

  signout = async () => {
    TokenService.removeTokens();
  };

  refreshTokenAuth = async (refreshToken: string) => {
    const response = await this.request.post<IChatbotAPIResponse<ITokens>>(
      '/auth/managers/refresh-token',
      { refreshToken }
    );

    const tokens = response.data.data;
    TokenService.setTokens(tokens);
    return TokenService.getDataFromToken() as IManager;
  };

  recoveryPassword = async (email: string) => {
    await this.request.post<Record<string, never>>('/auth/managers/recovery', {
      email
    });
  };

  resetPassword = async (requestData: IResetPasswordRequest) => {
    await this.request.post<Record<string, never>>('/auth/managers/reset', requestData);
  };
}
